import React, { useEffect, useMemo, useState } from "react";
import Card from "../../ui/Card";
import Table from "../../ui/Table";
import Stat from "../../ui/Stat";
import { fetchOrgSettings, saveOrgSettings } from "../../utils/orgData";
import { useAuth } from "../../context/AuthContext";

const PRICE_PER_SEAT_ZAR = 199; // adjust later

export default function BillingPage() {
  const { user, activeOrgId } = useAuth();
  const isReadOnly = user?.role === "investor";
  const [seats, setSeats] = useState(30);
  const [pricePerSeat, setPricePerSeat] = useState(PRICE_PER_SEAT_ZAR);
  const mrr = useMemo(() => seats * pricePerSeat, [seats, pricePerSeat]);

  useEffect(() => {
    let mounted = true;
    fetchOrgSettings(user, activeOrgId || "org_default")
      .then((settings) => {
        if (!mounted) return;
        if (settings.planSeats) setSeats(settings.planSeats);
        if (settings.pricePerSeat) setPricePerSeat(settings.pricePerSeat);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [user, activeOrgId]);

  useEffect(() => {
    if (isReadOnly) return;
    const orgId = activeOrgId || "org_default";
    saveOrgSettings(user, orgId, { planSeats: seats, pricePerSeat });
  }, [seats, pricePerSeat, isReadOnly, user, activeOrgId]);

  const invoices = [
    { Invoice: "INV-1008", Period: "Dec 2025", Amount: "R 5,172", Status: "Paid" },
    { Invoice: "INV-1009", Period: "Jan 2026", Amount: "R 5,970", Status: "Paid" },
    { Invoice: "INV-1010", Period: "Feb 2026", Amount: "R 5,970", Status: "Due" },
  ];
  const invoiceHeaders = ["Invoice", "Period", "Amount", "Status"];
  const invoiceRows = invoices.map((invoice) => [
    invoice.Invoice,
    invoice.Period,
    invoice.Amount,
    invoice.Status === "Paid" ? "Paid" : invoice.Status === "Due" ? "Due" : invoice.Status,
  ]);

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <Stat label="Current Plan" value="Nia COACH Business" />
        <div className="mt-3 grid gap-2 md:grid-cols-2">
          <div>
            <label className="label">Seats</label>
            <input
              type="number"
              className="input"
              min={1}
              value={seats}
              onChange={(e) => setSeats(Number(e.target.value || 1))}
              disabled={isReadOnly}
            />
          </div>
          <div>
            <label className="label">Price per seat</label>
            <input className="input" value={`R ${pricePerSeat}`} readOnly />
          </div>
        </div>
        <div className="mt-3 text-lg font-semibold">MRR: R {mrr.toLocaleString()}</div>
        <div className="mt-3 flex gap-2">
          <button className="btn btn-primary" disabled={isReadOnly}>Update payment method</button>
          <button className="btn btn-ghost" disabled={isReadOnly}>Download latest invoice</button>
        </div>
      </Card>

      <Card>
        <h3 className="text-lg font-semibold">Invoices</h3>
        <div className="mt-3">
          <Table
            headers={invoiceHeaders}
            rows={invoiceRows}
          />
        </div>
      </Card>
    </div>
  );
}
